module.exports = __webpack_public_path__ + "img/double_title.cf2d52ac.png";